import axios from "axios";
import { Form } from "devextreme-react";
import { Label } from "devextreme-react/data-grid";
import { EmptyItem, RequiredRule, SimpleItem } from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { detailedCmt, siteVisitTask } from "../data";
import {
  updasteSite,
  updasteVisitRptSedDate,
  updateCmt,
  updateDetailedCmt,
  updateTask,
  updateVisitDate,
} from "./Redux/siteVisit";
import styled from "styled-components";

const TaskFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function TaskForm(props) {
  const { contrNo, siteVisit, taskFormRef } = props;

  const dispatch = useDispatch();

  const [siteDataSource, setSiteDataSource] = useState(null);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/siteInfo/${contrNo}`
    );

    setSiteDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "siteNo",
        },
      })
    );
  }, [contrNo]);

  const itemRender = ({ siteNo, yadmNm, INSPCT_MANAGER_NAME }) => {
    return (
      <div>
        {/* {siteNo}-{LAB_NAME}-{INSPCT_MANAGER_NAME} */}
        {siteNo}-{yadmNm}-{INSPCT_MANAGER_NAME}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      // return `${item.siteNo}-${item.LAB_NAME}-${item.INSPCT_MANAGER_NAME}`;
      return `${item.siteNo}-${item.yadmNm}-${item.INSPCT_MANAGER_NAME}`;
    } else {
      return null;
    }
  };

  const onSiteNoValueChanged = (e) => {
    const site = siteDataSource
      .items()
      .find((element) => element.siteNo == e.value);

    dispatch(
      updasteSite({
        siteNo: e.value,
        siteLoc: site ? site.SIDO : null,
      })
    );
  };

  const onTaskValueChanged = (e) => {
    dispatch(
      updateTask({
        task: e.value,
      })
    );
  };

  const onVisitDateValueChanged = (e) => {
    dispatch(
      updateVisitDate({
        visitDate: e.value,
      })
    );
  };

  const onVisitRptSedDateValueChanged = (e) => {
    dispatch(
      updasteVisitRptSedDate({
        visitRptSedDate: e.value ? e.value : null,
      })
    );
  };

  const onDetailedCmtValueChanged = (e) => {
    dispatch(
      updateDetailedCmt({
        detailedCmt: e.value ? e.value : null,
      })
    );
  };

  const onCmtValueChanged = (e) => {
    dispatch(
      updateCmt({
        cmt: e.value ? e.value : null,
      })
    );
  };

  return (
    <TaskFormWrapper>
      <Form
        id="form-Task"
        ref={taskFormRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="taskData"
      >
        <SimpleItem
          dataField={"siteNo"}
          colSpan={2}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: siteDataSource,
            valueExpr: "siteNo",
            value: siteVisit.siteNo,
            readOnly: siteVisit.action == "insert" ? false : true,
            showClearButton: true,
            itemRender: itemRender,
            displayExpr: displayExpr,
            onValueChanged: onSiteNoValueChanged,
          }}
        >
          <Label text={"Site Info"} />
          <RequiredRule message={"Site info. is required."} />
        </SimpleItem>
        <EmptyItem />
        <SimpleItem
          dataField={"siteLoc"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: siteVisit.siteLoc,
            readOnly: true,
          }}
        >
          <Label text={"Site Location"} />
        </SimpleItem>
        <SimpleItem
          dataField={"task"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: siteVisitTask,
            valueExpr: "id",
            displayExpr: "name",
            value: siteVisit.task,
            showClearButton: true,
            searchEnabled: true,
            searchMode: "contains",
            onValueChanged: onTaskValueChanged,
          }}
        >
          <Label text={"Task"} />
          <RequiredRule message={"Task is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"visitDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: siteVisit.visitDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onVisitDateValueChanged,
          }}
        >
          <Label text={"Visit Date"} />
          <RequiredRule message={"Visit date is required"} />
        </SimpleItem>
        <SimpleItem
          dataField={"visitRptSedDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: siteVisit.visitRptSedDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onVisitRptSedDateValueChanged,
          }}
        >
          <Label text={"Visit Report Sending Date"} />
        </SimpleItem>
        <SimpleItem
          dataField={"detailedCmt"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: detailedCmt,
            valueExpr: "id",
            displayExpr: "name",
            value: siteVisit.detailedCmt,
            showClearButton: true,
            onValueChanged: onDetailedCmtValueChanged,
          }}
        >
          <Label text={"Detailed Comment"} />
        </SimpleItem>
        <SimpleItem
          dataField={"cmt"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: siteVisit.cmt,
            showClearButton: true,
            onValueChanged: onCmtValueChanged,
          }}
          colSpan={4}
        >
          <Label text={"Comment"} />
        </SimpleItem>
      </Form>
    </TaskFormWrapper>
  );
}
